//
//
//
//
//
//
//
//
//
//
//

import AppLink from "~/components/layout/AppLink.vue"
import logo from "~/components/Logo.vue"
import TogglerLang from '~/components/layout/TogglerLang'

export default {
    components: { AppLink, logo, TogglerLang },
    data() {
        return {
            ready: false
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.ready = true
        })
    }
}
